import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-total-discount',
  templateUrl: './tryout-total-discount.component.html',
  styleUrls: ['./tryout-total-discount.component.css']
})
export class TryoutTotalDiscountComponent implements OnInit {

  @Input() NoOfTotalDiscount: string;
  @Output() filterProgramsEvent = new EventEmitter();

  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-total-discount/tryout-total-discount.component.ts